import { render, staticRenderFns } from "./MaterialStandardMappingTabs.vue?vue&type=template&id=3b4d332e&scoped=true"
import script from "./MaterialStandardMappingTabs.vue?vue&type=script&lang=js"
export * from "./MaterialStandardMappingTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d332e",
  null
  
)

export default component.exports